export default {
  body: `
    Una cosa más: aunque no esté personalmente de acuerdo con el motivo de una
    pregunta, procure responderla.
  `,
  instruction: `
    Ahora pulse el botón <b>Continuar</b> para escuchar la primera pregunta.
  `,
};
